import { useContext, useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { ApplicationContext } from "../../contexts/ApplicationContext";
import SpeakerElement from "./Speaker";

function EventSpeakerView() {
    const { eventItem } = useContext(ApplicationContext);

    const [speaker, setSpeaker] = useState([]);

    const setupView = () => {
        if (eventItem) {
            const uniqueSpeakers:any = [...new Set(eventItem.sessions.flatMap((session: any) => session.speaker))];
            setSpeaker(uniqueSpeakers);
        }
    };

    useEffect(() => {
        setupView();
    }, [eventItem]);

    return (
        <Container>
            <Row className="align-items-start gap-3 mb-3">
                {speaker?.map((speaker: any, index: number) => (
                    <SpeakerElement key={index} speaker={speaker} agendaModalVisible={false} />
                ))
                }
            </Row>
        </Container>
    );
}

export default EventSpeakerView;